module.exports = __webpack_public_path__ + "static/media/rotate_cw.660e1af5.png";